import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  submit(event) {
    const prompt =
      event.params.prompt ||
      event.currentTarget.dataset.aiFollowUpQuestionsPromptParam;
    if (!prompt) return;

    const form = this.findComposerForm();
    if (!form) return;

    const input = form.querySelector(
      '[data-ai-chat-form-target="input"], textarea[name$="[input]"], textarea[name="ai_message[input]"]'
    );
    if (!input) return;

    input.value = prompt;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    this.submitForm(form);
  }

  findComposerForm() {
    const chat = this.element.closest('.amba-ai-chat__content, .amba-ai-chat');
    const scopedForm = chat?.querySelector(
      'form[data-controller~="ai-chat-form"]'
    );
    if (scopedForm) return scopedForm;

    const message = this.element.closest('[id^="ai_message_"]');
    const threadContainer = message?.parentElement;
    const frameForm =
      threadContainer?.nextElementSibling?.querySelector('form');
    if (frameForm) return frameForm;

    return (
      document.querySelector('form[data-controller~="ai-chat-form"]') ||
      document.querySelector('form textarea[name="ai_message[input]"]')?.form
    );
  }

  submitForm(form) {
    if (form.requestSubmit) {
      form.requestSubmit();
      return;
    }

    const submitButton = form.querySelector('[type="submit"]');
    if (submitButton) {
      submitButton.click();
      return;
    }

    form.submit();
  }
}
